import React from "react";
import { useNavigate } from "react-router-dom";

const AcademicManagement = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">Academic Management</h1>
          <p className="product-subtitleBg">
            Streamline curriculum planning, subject allocation, class schedules,
            assessments, and academic progress — all in one unified system.
          </p>
        </div>

        {/* ===== OVERVIEW ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/academicmanagement.jpg"
              alt="Academic Management"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              End-to-End Academic Control
            </h2>
            <p className="product-and-sol-section-text">
              Our Academic Management module helps institutions design curricula,
              manage subjects and classes, allocate teachers, and monitor
              academic performance with complete transparency.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Curriculum & syllabus planning</li>
              <li>✔ Class & section management</li>
              <li>✔ Teacher-subject allocation</li>
              <li>✔ Academic sessions & terms</li>
            </ul>
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">
          <FeatureCard
            title="Curriculum & Syllabus"
            description="Design structured academic programs and grading systems."
            icon={icons.curriculum}
            backgroundColor="#e9fdf3"
            typeClass="credentialing"
          />

          <FeatureCard
            title="Timetable Scheduling"
            description="Create conflict-free teacher and class schedules."
            icon={icons.timetable}
            backgroundColor="#f3ecff"
            typeClass="wallet"
          />

          <FeatureCard
            title="Assessments & Exams"
            description="Plan exams, evaluation criteria, and grading workflows."
            icon={icons.assessment}
            backgroundColor="#fff3cc"
            typeClass="education"
          />

          <FeatureCard
            title="Academic Progress"
            description="Track student performance across terms and subjects."
            icon={icons.progress}
            backgroundColor="#f1f6ff"
            typeClass="human-resources"
          />

          <FeatureCard
            title="Faculty Allocation"
            description="Assign teachers efficiently and balance workloads."
            icon={icons.faculty}
            backgroundColor="#ffe6dc"
            typeClass="marketing"
          />

          <FeatureCard
            title="Reports & Analytics"
            description="Generate academic insights and performance reports."
            icon={icons.reports}
            backgroundColor="#eaf9fa"
            typeClass="analytics"
          />
        </div>

        {/* ===== LMS / HIGHLIGHT SECTION ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Learning Management System (LMS)
              </h2>
              <p className="ps-highlight-subtitle">
                Seamless, All-in-One Digital Learning Platform
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Create, manage, and deliver engaging courses for online,
                hybrid, and traditional classrooms.
              </p>

              <div className="ps-highlight-grid">
                <div className="ps-highlight-item ps-bg-blue">
                  <strong>Flexible Delivery:</strong> Online & hybrid learning
                </div>
                <div className="ps-highlight-item ps-bg-green">
                  <strong>Smart Content:</strong> Adaptive learning paths
                </div>
                <div className="ps-highlight-item ps-bg-purple">
                  <strong>Live Tracking:</strong> Engagement analytics
                </div>
              </div>

              <div className="ps-button-group">
                <div className="button-box">
                  <button
                    className="btn"
                    onClick={() =>
                      navigate("/academic-management/lms-readmore")
                    }
                  >
                    <span className="btn-wrap">
                      <span className="text-one">Read More</span>
                      <span className="text-two">Read More</span>
                    </span>
                  </button>
                </div>

                <div className="button-box">
                  <button
                    className="btn btn-three"
                    onClick={() =>
                      navigate("/contact#Contact-form")
                    }
                  >
                    <span className="btn-wrap">
                      <span className="text-one">Contact Us</span>
                      <span className="text-two">Contact Us</span>
                    </span>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== FEATURE CARD COMPONENT ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  curriculum: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 4h16v16H4z" stroke="#5a5cff" strokeWidth="2" />
      <path d="M8 4v16M16 4v16" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  timetable: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="#ff8c00" strokeWidth="2" />
      <path d="M3 10h18M8 14h4M14 14h4" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  assessment: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 19V5h16v14" stroke="#0ca85c" strokeWidth="2" />
      <path d="M8 9h8M8 13h5" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  progress: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 20V12M10 20V8M16 20V4" stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  faculty: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="7" r="4" stroke="#6c5ce7" strokeWidth="2" />
      <path d="M5 21c0-4 14-4 14 0" stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  reports: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="3" width="14" height="18" rx="2" stroke="#0097e6" strokeWidth="2" />
      <path d="M9 11h6M9 15h4" stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default AcademicManagement;
